import React, { FC } from "react";
import { Collapse, Checkbox, Input, Spin } from "antd";

import "./filterForDayCalender.scss";
import "../../../../../../style/main.scss";

import { RightOutlined } from "@ant-design/icons";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

const { Panel } = Collapse;

const FilterForDayCalender: FC<any> = ({ isloadingFilter, officeObject, copyOfficeObject, onOfficeSelection, providerTypeObject, onProviderTypeSelection ,copyProviderTypeObject ,providerNameObject, copyProviderNameObject, onProviderNameSelection, copyTempDayFilter, onSearchOptionsOffice, onSearchOptionsProviderType, onSearchOptionsProviderName, activePanels, onCollapseChange }) => {
  
  
  return (
    <>
      {isloadingFilter ? (
        <div className="loaderForFilter">
          <Spin size="large" indicator={<HealthemSpinner/>} />
        </div>
      ) : null}
      <div className="drawerFiltersWrapper">
        {!isloadingFilter ? (
          <Collapse activeKey={activePanels} expandIconPosition={"right"} onChange={(key)=>onCollapseChange(key)} expandIcon={({ isActive }) => <RightOutlined style={{ fontSize: "14px", color: "#42526e" }} />}>
            <Panel header={officeObject?.label} key={officeObject.column} className={`filtersPanel`}>
              {officeObject?.options?.length > 5 ? <Input onChange={(e) => onSearchOptionsOffice(e.target.value)} allowClear={true} className="inputForSearchFilter" placeholder={`Search ${officeObject.label.split(" ").map((str: any) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()).join(" ")}`} /> : null}

              <Checkbox.Group
              value={officeObject?.selectedOffice.length > 0 ? [officeObject?.selectedOffice] : []}
                options={copyOfficeObject?.options}
                onChange={(selectedArray) => {
                  onOfficeSelection(selectedArray, officeObject.column)
                }}
                className={`${officeObject?.options?.length > 5 ? "panelWithMoreOption custom-scroll-bar" : "providerType"}`}
              />
            </Panel>
            {
              officeObject?.selectedOffice?.length > 0 ? (
                <Panel header={providerTypeObject?.label} key={providerTypeObject.column} className={`filtersPanel`}>
                {providerTypeObject?.options?.length > 5 ? <Input onChange={(e) => onSearchOptionsProviderType(e.target.value)} allowClear={true} className="inputForSearchFilter" placeholder={`Search ${providerTypeObject.label.split(" ").map((str: any) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()).join(" ")}`} /> : null}
  
                <Checkbox.Group
                  value={copyTempDayFilter["provider_type"]}
                  options={copyProviderTypeObject?.options}
                  onChange={(selectedArray) => {
                    onProviderTypeSelection(selectedArray, providerTypeObject.column)
                  }}
                  className={`${providerTypeObject?.options?.length > 5 ? "panelWithMoreOption custom-scroll-bar" : ""}`}
                />
              </Panel>
              ) : null
            }
             {officeObject?.selectedOffice?.length > 0 ? (
                <Panel header={providerNameObject?.label} key={providerNameObject.column} className={`filtersPanel`}>
                {providerNameObject?.options?.length > 5 ? <Input onChange={(e) => onSearchOptionsProviderName(e.target.value)} allowClear={true} className="inputForSearchFilter" placeholder={`Search ${providerNameObject.label.split(" ").map((str: any) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()).join(" ")}`} /> : null}
  
                <Checkbox.Group
                  value={copyTempDayFilter["provider_name"]}
                  options={copyProviderNameObject?.options}
                  onChange={(selectedArray) => {
                    onProviderNameSelection(selectedArray, providerNameObject.column)
                  }}
                  className={`${providerNameObject?.options?.length > 5 ? "panelWithMoreOption custom-scroll-bar" : ""}`}
                />
              </Panel>
              ) : null}

          </Collapse>
        ) : null}
      </div>
    </>
  );
};

export default FilterForDayCalender;
